<template>
  <div class="cotton-inspection-search">
    <el-form ref="form" :model="model" :inline="true" :rules="rules">
      <el-form-item :label="`${$t('设备号')}:`" prop="alarmType">
        <!-- <el-input v-model="model.sn" /> -->
        <el-select v-model="model.sn" clearable :placeholder="$t('请选择')">
          <el-option v-for="v in deviceList" :key="v.sn" :label="v.name" :value="v.sn" />
        </el-select>
      </el-form-item>

      <el-form-item :label="`${$t('报警时间')}:`" prop="dateRange">
        <el-date-picker
          v-model="model.dateRange"
          type="datetimerange"
          :range-separator="$t('至')"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')"
          value-format="timestamp"
          @change="dateChange"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="validateEvent" :loading="loading">
          {{ $t('查询') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import { getTime, toTimestamp } from '@/utils/date';
import { mapState } from 'vuex';
import { getOffice } from '@/api/auth';
import { getDevicesList } from '@/api/baseInfo';
import deviceType from '@/utils/const/deviceType';

export default {
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    operation: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deviceList: [],
      officeTreeParams: {
        data: [],
        checkStrictly: true,
        multiple: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      }
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  methods: {
    dateChange(_val) {
      // if (!val || !val[0] || !val[1]) return;
      // const begin = toTimestamp(val[0], 'm');
      // const end = toTimestamp(val[1], 'm');
      // const range = getTime('h') * 24;
      // if (end - begin > range) {
      //   this.model.dateRange.splice(0, Infinity, begin, begin + getTime('h'));
      // } else {
      //   this.model.dateRange.splice(0, Infinity, begin, end);
      // }
    },

    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('search', this.model);
        } else {
          return false;
        }
      });
    },
    getOffices() {
      const promiseList = [];
      const task = getOffice({
        busiType: 2
      });
      promiseList.push(task);
      task.then(res => {
        Object.assign(this.officeTreeParams, { data: res.data });
      });
    },
    async getDeviceList() {
      try {
        const { officeIds } = this.model;
        const res = await getDevicesList({
          officeId: officeIds,
          deviceModel: [deviceType.CD_602]
        });
        this.deviceList = res.data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    'model.officeIds': 'getDeviceList'
  },
  mounted() {
    this.getOffices();
    this.getDeviceList();
  }
};
</script>

<style></style>
